import * as types from '../types';

export const startFetchingDestinations = (filters = {}) => ({
  type: types.ETAMONITORING_DESTINATIONS_FETCH_STARTED,
  payload: filters
});

export const completeFetchingDestination = (entities, order, operatorId, organizationId) => ({
  type: types.ETAMONITORING_DESTINATIONS_FETCH_COMPLETED,
  payload: {
    entities,
    order,
    operatorId,
    organizationId
  }
});

export const failFetchingDestination = (error = { errorMessage: 'Error', errorNumber: 404 }) => ({
  type: types.ETAMONITORING_DESTINATIONS_FETCH_FAILED,
  payload: {
    error //error:{errorMessage:'Error', errorNumber:400}
  }
});
